
import { useState, useEffect } from 'react';

export default function GigaSchoolProposal() {
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showCompassKitModal, setShowCompassKitModal] = useState(false);
  const [showCompassForm, setShowCompassForm] = useState(false);

  const handleAdminAccess = () => {
    setShowPasswordModal(true);
    setPassword('');
    setPasswordError('');
  };

  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === '7878') {
      setShowPasswordModal(false);
      if (typeof window.REACT_APP_NAVIGATE === 'function') {
        window.REACT_APP_NAVIGATE('/admin');
      } else {
        console.error('REACT_APP_NAVIGATE is not defined or not a function');
      }
    } else {
      setPasswordError('パスワードが正しくありません');
      setPassword('');
    }
  };

  const closePasswordModal = () => {
    setShowPasswordModal(false);
    setPassword('');
    setPasswordError('');
  };

  const handleCompassKitRequest = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    try {
      const response = await fetch(
        'https://readdy.ai/api/form/d3grvq2o4dav5srlktsg',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(formData as any).toString(),
        }
      );

      if (response.ok) {
        alert('羅針盤キットのお申し込みありがとうございます！ダウンロードリンクをメールでお送りいたします。');
        (e.target as HTMLFormElement).reset();
        setShowCompassKitModal(false);
      } else {
        alert('送信に失敗しました。もう一度お試しください。');
      }
    } catch (error) {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  };

  // SEO設定
  useEffect(() => {
    document.title = "AGI時代の羅針盤キット | AI育成学舎";

    const metaDescription = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    metaDescription.setAttribute(
      'content',
      'AGI時代の羅針盤キット。AIに心を持たせ、思考の画一化を防ぐ。プロンプト技術の陳腐化に備え、人間の普遍的な判断力をインストールします。'
    );
    if (!document.querySelector('meta[name="description"]')) {
      document.head.appendChild(metaDescription);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* ヒーローセクション */}
      <section
        className="relative py-20 bg-cover bg-center bg-top"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/fc3dc269a64b18f3b1a299f6db1e7430.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 via-purple-900/70 to-indigo-900/80"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
          <div className="mb-8">
            <h1 className="text-7xl font-bold leading-tight mb-6">
              【AGI時代の羅針盤】
              <span className="block text-6xl bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent mt-4">
                AIに心を持たせ、思考の画一化を防ぐ。
              </span>
            </h1>
            <h2 className="text-4xl font-bold mb-8 text-red-300">
              「プロンプト技術は、もうすぐ通用しなくなる。」
            </h2>
            <p className="text-2xl font-medium mb-8 opacity-90 leading-relaxed">
              GIGAスクール2.0のその先へ—私たちは、AIの進化に流されない<br />
              <span className="text-yellow-300 font-bold">「人間の普遍的な判断力」</span>をインストールします。
            </p>

            <p className="text-xl text-cyan-200 mb-8">
              AIの答えを鵜呑みにしない「感覚資産」を、子どもたちへ。
            </p>

            {/* 未来の子供たちからの手紙リンク */}
            <div className="mb-8">
              <button
                onClick={() =>
                  window.open(
                    'https://docs.google.com/document/d/1NmLvwm3xd6ZsyhljgCzj4ilFrtJmrVaLWt-iUG-tAh8/edit?usp=sharing',
                    '_blank'
                  )
                }
                className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-cyan-600 hover:to-blue-700 transition-all transform hover:scale-105 shadow-lg inline-flex items-center gap-3 border-2 border-white/30"
              >
                <span>AI時代に自分を見失わないために<br />✉️ 未来の子供たちからの手紙</span>
                <i className="ri-external-link-line text-xl"></i>
              </button>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => setShowCompassKitModal(true)}
                className="bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-yellow-600 hover:to-orange-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
              >
                <i className="ri-compass-3-line text-xl"></i>
                羅針盤キットを入手
              </button>

              <button
                onClick={() => {
                  if (typeof window.REACT_APP_NAVIGATE === 'function') {
                    window.REACT_APP_NAVIGATE('/');
                  } else {
                    console.error('REACT_APP_NAVIGATE is not defined or not a function');
                  }
                }}
                className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all border border-white/30 whitespace-nowrap inline-flex items-center gap-3"
              >
                <i className="ri-arrow-left-line text-xl"></i>
                ホームに戻る
              </button>
            </div>
          </div>

          <div className="bg-black/30 backdrop-blur-md rounded-3xl p-8 max-w-4xl mx-auto border border-white/20 mb-8">
            <h3 className="text-2xl font-bold text-yellow-300 mb-4">【指導者・教育関係者様へ】</h3>
            <p className="text-lg leading-relaxed opacity-95 mb-6">
              提言書と指導者向けキット（無料）を今すぐダウンロードし、未来の教育を設計してください。
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => setShowCompassKitModal(true)}
              className="bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-yellow-600 hover:to-orange-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-compass-3-line text-xl"></i>
              羅針盤キットを入手
            </button>

            <button
              onClick={() => {
                if (typeof window.REACT_APP_NAVIGATE === 'function') {
                  window.REACT_APP_NAVIGATE('/');
                } else {
                  console.error('REACT_APP_NAVIGATE is not defined or not a function');
                }
              }}
              className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all border border-white/30 whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              ホームに戻る
            </button>
          </div>
        </div>
      </section>

      {/* 危機の説明セクション */}
      <section className="py-20 bg-gradient-to-br from-red-50 to-orange-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              GIGAスクール2.0のその先へ：
              <span className="block text-4xl text-red-600 mt-4">
                なぜ、今「羅針盤」が必要なのか？
              </span>
            </h2>
          </div>

          <div className="bg-white rounded-3xl p-12 shadow-xl border border-red-200 mb-16">
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-alarm-warning-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">静かな危機が進行している</h3>
            </div>

            <div className="max-w-4xl mx-auto">
              <p className="text-xl text-gray-700 leading-relaxed mb-8">
                私たちは、AI教育の現場で<strong className="text-red-600">静かな危機</strong>が進行していることを知っています。それは、AIを単なる「効率化ツール」として使うことで、子どもたちの<strong className="text-blue-600">「考える力」</strong>と<strong className="text-blue-600">「自ら決める力」</strong>が奪われ、<strong className="text-red-600">思考が画一化</strong>してしまうことです。
              </p>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-2xl mb-8">
                <p className="text-lg text-gray-800 leading-relaxed">
                  特に、AIが人間の言葉を深く理解する<strong className="text-purple-600">AGI（汎用人工知能）</strong>の時代が訪れると、今学んでいる<strong className="text-red-600">プロンプト技術は陳腐化</strong>します。未来の指導者に求められるのは、<strong className="text-green-600">「AIの進化に左右されない、普遍的な人間の軸」</strong>を育むことです。
                </p>
              </div>
            </div>
          </div>

          {/* YouTube動画セクション */}
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8 shadow-xl border border-blue-200 mb-16">
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-play-circle-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">詳細解説動画</h3>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                羅針盤キットの詳細な解説と、GIGAスクール2.0への具体的な提言内容をご覧ください。
              </p>
            </div>

            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h4 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  GIGAスクール2.0強化提言：AI時代の羅針盤キット
                </h4>

                <div className="aspect-video bg-gray-100 rounded-xl mb-6 flex items-center justify-center">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-youtube-line text-2xl text-white"></i>
                    </div>
                    <p className="text-gray-600 mb-4">YouTube動画で詳細をご確認ください</p>
                    <button
                      onClick={() => window.open('https://youtu.be/GH6wPOtn6IQ', '_blank')}
                      className="bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-red-600 hover:to-red-700 transition-all transform hover:scale-105 shadow-lg inline-flex items-center gap-3"
                    >
                      <i className="ri-play-line text-xl"></i>
                      動画を視聴する
                    </button>
                  </div>
                </div>

                <div className="grid md:grid-cols-3 gap-4 text-sm">
                  <div className="flex items-center gap-2 text-gray-600">
                    <i className="ri-time-line text-blue-500"></i>
                    <span>詳細解説動画</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-600">
                    <i className="ri-government-line text-green-500"></i>
                    <span>政策提言内容</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-600">
                    <i className="ri-compass-3-line text-purple-500"></i>
                    <span>羅針盤キット紹介</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 関連論文セクション */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8 shadow-xl border border-green-200 mb-16">
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">関連論文・資料</h3>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                羅針盤キットの理論的背景と実践的指導法に関する詳細な論文をご覧いただけます。
              </p>
            </div>

            <div className="max-w-5xl mx-auto">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-green-100">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-government-line text-xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-gray-900 mb-2">GIGAスクール構想2.0強化提言</h4>
                      <p className="text-gray-600 text-sm mb-4">
                        現行のGIGAスクール構想の課題分析と、AI時代に対応した教育政策の具体的提言
                      </p>
                      <button
                        onClick={() =>
                          window.open(
                            'https://docs.google.com/document/d/1JU9JHeihp0ZU__Xo78L7wtK3VL94XTYoUqezNDmR1yI/edit?usp=sharing',
                            '_blank'
                          )
                        }
                        className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-bold hover:from-blue-600 hover:to-purple-700 transition-all inline-flex items-center gap-2"
                      >
                        <i className="ri-external-link-line"></i>
                        論文を読む
                      </button>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg border border-green-100">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-heart-3-line text-xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-gray-900 mb-2">感覚資産を育む教育観の確立</h4>
                      <p className="text-gray-600 text-sm mb-4">
                        AI時代における人間固有の感覚と直感を重視した新しい教育パラダイムの理論的基盤
                      </p>
                      <button
                        onClick={() =>
                          window.open(
                            'https://docs.google.com/document/d/1ys0w4lLejAu2LewoJFgg4UmYXsAJkWaOxb72VuCTljs/edit?usp=sharing',
                            '_blank'
                          )
                        }
                        className="bg-gradient-to-r from-orange-500 to-red-600 text-white px-4 py-2 rounded-full text-sm font-bold hover:from-orange-600 hover:to-red-700 transition-all inline-flex items-center gap-2"
                      >
                        <i className="ri-external-link-line"></i>
                        論文を読む
                      </button>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg border border-green-100">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-brain-line text-xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-gray-900 mb-2">未来の知性をインストールする</h4>
                      <p className="text-gray-600 text-sm mb-4">
                        AGI時代に向けた人間の普遍的判断力の育成方法と実践的アプローチ
                      </p>
                      <button
                        onClick={() =>
                          window.open(
                            'https://docs.google.com/document/d/16FvqetuSdwwiuCJdRVBWIQbQaYUbXSE4cBpL-FOEaD0/edit?usp=sharing',
                            '_blank'
                          )
                        }
                        className="bg-gradient-to-r from-purple-500 to-pink-600 text-white px-4 py-2 rounded-full text-sm font-bold hover:from-purple-600 hover:to-pink-700 transition-all inline-flex items-center gap-2"
                      >
                        <i className="ri-external-link-line"></i>
                        論文を読む
                      </button>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg border border-green-100">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-star-line text-xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-gray-900 mb-2">教師向け「ICT指導員も納得の」ガイド</h4>
                      <p className="text-gray-600 text-sm mb-4">
                        現場の教師とICT指導員が協働で実践できる羅針盤キットの具体的指導法
                      </p>
                      <button
                        onClick={() =>
                          window.open(
                            'https://docs.google.com/document/d/12VXsRy6SsLSG8yc-pqnGtwKrXcKzLjhFAZLFSVulUy4/edit?usp=sharing',
                            '_blank'
                          )
                        }
                        className="bg-gradient-to-r from-green-500 to-teal-600 text-white px-4 py-2 rounded-full text-sm font-bold hover:from-green-600 hover:to-teal-700 transition-all inline-flex items-center gap-2"
                      >
                        <i className="ri-external-link-line"></i>
                        論文を読む
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 羅針盤の説明セクション */}
          <section className="py-20 bg-white">
            <div className="max-w-6xl mx-auto px-6">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  羅針盤が育む二つの「感覚資産」
                </h2>
                <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                  AI育成学舎が提案する<strong className="text-blue-600">「AI時代の羅針盤キット」</strong>は、この危機に対する<strong className="text-green-600">最も現実的な解決策</strong>です。私たちは、日本の教育観に根ざした<strong className="text-purple-600">二つの羅針盤</strong>で、子どもたちの<strong className="text-orange-600">「感覚資産」</strong>を育みます。
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-12 mb-16">
                {/* おもいやり羅針盤 */}
                <div className="bg-gradient-to-br from-pink-50 to-red-50 rounded-3xl p-10 border border-pink-200 shadow-xl">
                  <div className="text-center mb-8">
                    <div className="w-20 h-20 bg-gradient-to-br from-pink-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                      <i className="ri-heart-3-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-2">おもいやり羅針盤</h3>
                    <p className="text-lg text-pink-700 font-medium">価値判断力</p>
                  </div>

                  <div className="space-y-6">
                    <p className="text-gray-700 leading-relaxed">
                      AIの論理的な回答に対し、<strong className="text-pink-600">「誰への配慮が必要か」「何を大切にすべきか」</strong>という<strong className="text-red-600">人間の心と倫理</strong>を注入させます。
                    </p>

                    <div className="bg-white rounded-2xl p-6 shadow-lg">
                      <h4 className="font-bold text-gray-900 mb-3">育む力</h4>
                      <ul className="space-y-2 text-gray-700">
                        <li className="flex items-start gap-3">
                          <i className="ri-check-line text-pink-505 mt-1"></i>
                          <span>日本的な「調和」や「曖昧さ（ゆらぎ）」の理解</span>
                        </li>
                        <li className="flex items-start gap-3">
                          <i className="ri-check-line text-pink-505 mt-1"></i>
                          <span>最適解ではない、しかし最も人間的な答えを探る力</span>
                        </li>
                        <li className="flex items-start gap-3">
                          <i className="ri-check-line text-pink-505 mt-1"></i>
                          <span>多様な価値観への配慮と共感力</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* しんちょう羅針盤 */}
                <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-10 border border-blue-200 shadow-xl">
                  <div className="text-center mb-8">
                    <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                      <i className="ri-brain-line text-3xl text-white"></i>
                    </div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-2">しんちょう羅針盤</h3>
                    <p className="text-lg text-blue-700 font-medium">変化適応力</p>
                  </div>

                  <div className="space-y-6">
                    <p className="text-gray-700 leading-relaxed">
                      AIの<strong className="text-blue-600">「完璧な答え」</strong>に対し、<strong className="text-purple-600">「直感的な違和感」</strong>の声を言語化させます。データや論理を超えた<strong className="text-blue-600">自分の感覚を信じる力</strong>を鍛えます。
                    </p>

                    <div className="bg-white rounded-2xl p-6 shadow-lg">
                      <h4 className="font-bold text-gray-900 mb-3">育む力</h4>
                      <ul className="space-y-2 text-gray-700">
                        <li className="flex items-start gap-3">
                          <i className="ri-check-line text-blue-600 mt-1"></i>
                          <span>直感的な違和感を言語化する能力</span>
                        </li>
                        <li className="flex items-start gap-3">
                          <i className="ri-check-line text-blue-600 mt-1"></i>
                          <span>最終的な判断の責任をAIに委ねない自律性</span>
                        </li>
                        <li className="flex items-start gap-3">
                          <i className="ri-check-line text-blue-600 mt-1"></i>
                          <span>変化に対する柔軟な適応力と批判的思考</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 指導者様へ：最小限の負荷で、最大の効果を */}
          <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
            <div className="max-w-6xl mx-auto px-6">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  指導者様へ：最小限の負荷で、最大の効果を
                </h2>
                <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
                  羅針盤キットは、従来の教育手法を大きく変えることなく、<br />
                  AI時代に必要な判断力を効率的に育成する革新的なツールです。
                </p>
              </div>

              <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
                <div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-6">空白の羅針盤設計</h3>
                  <div className="space-y-6">
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-lightbulb-line text-white text-sm"></i>
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">思考の可視化</h4>
                        <p className="text-gray-700">
                          学習者の思考プロセスを段階的に整理し、判断の根拠を明確にします。
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-team-line text-white text-sm"></i>
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">協働学習の促進</h4>
                        <p className="text-gray-700">
                          異なる視点を持つ学習者同士の対話を通じて、多角的な思考を育成します。
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-refresh-line text-white text-sm"></i>
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">継続的な改善</h4>
                        <p className="text-gray-700">
                          学習の振り返りを通じて、判断力を段階的に向上させていきます。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=Educational%20compass%20design%20with%20blank%20spaces%20for%20student%20input%2C%20modern%20minimalist%20style%2C%20clean%20white%20background%2C%20subtle%20blue%20accents%2C%20professional%20educational%20tool%20visualization%2C%20geometric%20compass%20shape%20with%20empty%20sections%20for%20writing%2C%20inspiring%20and%20organized%20layout&width=600&height=400&seq=compass-design&orientation=landscape"
                    alt="空白の羅針盤設計"
                    className="rounded-2xl shadow-2xl w-full object-cover"
                  />
                </div>
              </div>

              <div className="bg-white rounded-3xl p-8 shadow-xl mb-16">
                <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                  AGI対応の指導観
                </h3>
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="space-y-6">
                    <h4 className="text-xl font-semibold text-blue-600 mb-4">従来の指導観</h4>
                    <div className="space-y-4">
                      <div className="flex items-center space-x-3">
                        <i className="ri-close-circle-line text-red-500 text-xl"></i>
                        <span className="text-gray-700">知識の一方的な伝達</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-close-circle-line text-red-500 text-xl"></i>
                        <span className="text-gray-700">正解の暗記重視</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-close-circle-line text-red-5​00 text-xl"></i>
                        <span className="text-gray-700">個別学習中心</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-close-circle-line text-red-500 text-xl"></i>
                        <span className="text-gray-700">結果のみの評価</span>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-6">
                    <h4 className="text-xl font-semibold text-green-600 mb-4">AGI対応の指導観</h4>
                    <div className="space-y-4">
                      <div className="flex items-center space-x-3">
                        <i className="ri-check-circle-line text-green-5​00 text-xl"></i>
                        <span className="text-gray-700">思考プロセスの共有</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-check-circle-line text-green-500 text-xl"></i>
                        <span className="text-gray-700">AIと人間の協働のバランス</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-check-circle-line text-green-500 text-xl"></i>
                        <span className="text-gray-700">主体的な学びの促進</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-check-circle-line text-green-500 text-xl"></i>
                        <span className="text-gray-700">感覚資産に基づく評価</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-blue-600 to-purple-700 rounded-3xl p-8 text-white">
                <h3 className="text-3xl font-bold mb-8 text-center">羅針盤キット実装の流れ</h3>
                <div className="grid md:grid-cols-4 gap-6">
                  {/* Step 1 */}
                  <div className="text-center">
                    <div className="w-16 ...">
                    </div>
                    <h4 className="text-lg font-semibold mb-2">導入準備</h4>
                    <p className="text-sm text-blue-100">既存カリキュラムとの統合計画を策定</p>
                  </div>
                  {/* Step 2 */}
                  <div className="text-center">
                    <div className="w-16 ...">
                    </div>
                    <h4 className="text-lg font-semibold mb-2">試行実施</h4>
                    <p className="text-sm text-blue-100">小規模グループでの効果検証</p>
                  </div>
                  {/* Step 3 */}
                  <div className="text-center">
                    <div className="w-16 ...">
                    </div>
                    <h4 className="text-lg font-semibold mb-2">拡大実施</h4>
                    <p className="text-sm text-blue-100">全校への広範な導入</p>
                  </div>
                  {/* Step 4 */}
                  <div className="text-center">
                    <div className="w-16 ...">
                    </div>
                    <h4 className="text-lg font-semibold mb-2">効果評価</h4>
                    <p className="text-sm text-blue-100">ロングタームでの判断力成長度測定</p>
                  </div>
                </div>
              </div>

            </div>
          </section>

          {/* 羅針盤キットセクション - 復元 */}
          <section className="py-20 bg-gradient-to-br from-yellow-50 to-orange-50">
            <div className="max-w-6xl mx-auto px-6 text-center">
              <h2 className="text-5xl font-bold text-gray-900 mb-6">
                「羅針盤キット」で、未来のAI教育へ舵を切る。
              </h2>
              <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed mb-8">
                羅針盤キットは、GIGAスクール2.0から飛び出した先にある次世代教育の実践を、具体的かつすぐに始められるようにするものです。プロンプト技術を超えた、「心ある判断」と「感覚資産」の育成を目指します。
              </p>
              
              <div className="bg-white rounded-3xl p-8 shadow-xl border border-orange-200 max-w-4xl mx-auto mb-12">
                <h3 className="text-3xl font-bold text-orange-800 mb-6">
                  次世代教育への一歩を、今踏み出そう。
                </h3>
              </div>
            </div>
          </section>

        </div>
      </section>

      {/* Password Modal */}
      {showPasswordModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white rounded-lg p-6 w-80">
            <h2 className="text-lg font-bold mb-4">管理者アクセス</h2>
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                placeholder="パスワード"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border rounded p-2 mb-2"
                required
              />
              {passwordError && <p className="text-red-500 text-sm">{passwordError}</p>}
              <div className="flex justify-end gap-2 mt-4">
                <button type="button" onClick={closePasswordModal} className="px-4 py-2 bg-gray-200 rounded">
                  キャンセル
                </button>
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">
                  OK
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Compass Kit Modal */}
      {showCompassKitModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
            <h2 className="text-xl font-bold mb-4">羅針盤キットのお申し込み</h2>
            <form onSubmit={handleCompassKitRequest}>
              <div className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    お名前 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full border rounded p-2"
                    placeholder="例）田中 太郎"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    メールアドレス <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full border rounded p-2"
                    placeholder="例）taro@example.com"
                  />
                </div>
                <div>
                  <label htmlFor="schoolName" className="block text-sm font-medium text-gray-700 mb-1">
                    学校名（任意）
                  </label>
                  <input
                    type="text"
                    id="schoolName"
                    name="schoolName"
                    className="w-full border rounded p-2"
                    placeholder="例）〇〇小学校"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                    メッセージ（任意）
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    className="w-full border rounded p-2"
                    placeholder="ご質問やご希望があればご記入ください"
                  ></textarea>
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button type="button" onClick={() => setShowCompassKitModal(false)} className="px-4 py-2 bg-gray-200 rounded">
                  キャンセル
                </button>
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">
                  送信
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
